import React, { useEffect, useState } from "react";
import { Pencil } from "lucide-react";

/**
 * Single-line truncated text + pencil affordance that swaps to a controlled
 * input on edit. Commits on Enter or blur, reverts on Escape.
 */
export default function InlineText({ value, onCommit, disabled, dataTestid }) {
  const [editing, setEditing] = useState(false);
  const [val, setVal] = useState(value);
  useEffect(() => setVal(value), [value]);

  if (!editing) {
    return (
      <div className="flex-1 min-w-0 flex items-center gap-1 group/title">
        <span
          className="text-xs text-ink truncate flex-1"
          title={value}
          data-testid={dataTestid}
        >
          {value || <span className="text-ink-mute mono text-2xs">— untitled —</span>}
        </span>
        {!disabled && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setEditing(true);
            }}
            className="opacity-0 group-hover/title:opacity-100 transition-opacity text-ink-mute hover:text-amber shrink-0"
            title="Edit title"
            data-testid={dataTestid + "-edit"}
          >
            <Pencil className="w-2.5 h-2.5" />
          </button>
        )}
      </div>
    );
  }
  return (
    <input
      autoFocus
      className="inline-input text-xs flex-1"
      value={val}
      onChange={(e) => setVal(e.target.value)}
      onBlur={() => {
        setEditing(false);
        onCommit(val);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") e.currentTarget.blur();
        if (e.key === "Escape") {
          setVal(value);
          setEditing(false);
        }
      }}
      onClick={(e) => e.stopPropagation()}
      data-testid={dataTestid + "-input"}
    />
  );
}
